import { AdvancedSearchCondition } from '@/constants/advancedSearch'

export const getFilterConditionKey = value => Object.keys(AdvancedSearchCondition).reduce((conditionKey, key) => {
  if (AdvancedSearchCondition[key] === value) {
    conditionKey = key
  }

  return conditionKey
}, null)
